import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

export function useShouldAddDenominatorClause() {
  return useQuantifyStore(
    ({ query }) =>
      query.formulaQuery?.eqlFunction === EQLFunctionName.NormaliseByPercent,
  );
}
